"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var react_1 = __importDefault(require("react"));
var useRovingTabIndex_1 = require("../../hooks/useRovingTabIndex");
var styles_1 = require("../../styles");
function Tabs(props) {
    var style = props.style, rest = __rest(props, ["style"]);
    var _a = styles_1.useStyles(createStyles), classes = _a.classes, css = _a.css;
    var rootRef = useRovingTabIndex_1.useRovingTabIndex({
        getItems: function (root) { return Array.from(root.querySelectorAll("[role=\"tab\"]:not(.disabled)")); },
    });
    return react_1.default.createElement("ul", __assign({ ref: rootRef, className: css(classes.ul, style), role: 'tablist' }, rest));
}
exports.Tabs = Tabs;
var createStyles = function (theme) { return ({
    ul: {
        display: 'flex',
        alignItems: 'flex-end',
        listStyle: 'none',
        padding: '0',
        margin: '0',
        fontSize: theme.typography.sizes.button,
        borderBottom: "1px solid " + theme.pallete.divider,
    },
}); };
//# sourceMappingURL=Tabs.js.map